import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ChatStateService } from 'src/app/services/chat-state.service';
// import { CoreaiService } from 'src/app/services/coreai.service';

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.scss']
})
export class WelcomeScreenComponent implements OnInit {
  promptList: any[] = [];
  userName!: string;

  constructor(
    private chatStateService: ChatStateService,
    private authService: AuthService,
    // private router: Router,
    // private coreAIService: CoreaiService,
    private route: ActivatedRoute,
    private router:Router
  ) {

    this.userName = this.authService.getUserName();
    this.getPromptList();
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe((res: any) => {
      if (res?.prompt || res?.pg_prompt) {
        let queryPrompt = res?.prompt || res?.pg_prompt
        this.chatStateService.promptInputState.next(queryPrompt);
      }
    })


  }

  sentToInput(data: any) {
    if(data?.isLink) {
      if(data?.title == 'DataLabs'|| 'Data Forge'){
        this.router.navigate([data?.link]);
        return;
      }
      this.router.navigate(['/podcast-generator']);
    } else {
      if(data?.title.includes('Smart Summary')) {
        this.chatStateService.fileuploadSignal(true);
      }
      this.chatStateService.promptInputState.next(data?.prompt);
    }
  }

  getPromptList() {

    this.promptList = [
      {
        id: 1,
        title: 'PodLabs',
        isBeta: true,
        isLink: true,
        isPlugin:true,
        link:'/podcast-generator',
        prompt: 'Let AI turn your files into captivating podcasts!',
        icon: `podcast.svg`
      },
      {
        id: 2,
        title: 'Data Forge',
        isBeta: true,
        isLink: true,
        isPlugin:true,
        link:'/datalabs',
        prompt: 'Transform raw data into powerful insights with AI-powered analysis tools',
        icon: `datalabs.svg`
      },
      {
        id: 2,
        title: 'Prompt Builder',
        isBeta: true,
        isLink: true,
        isPlugin:true,
        link:'/prompt-generator',
        prompt: 'Pre-trained system that helps you quickly generate effective prompts for AI generators',
        icon: `testcase.svg`
      },
      {
        id: 5,
        title: 'Translation',
        isBeta: false,
        isLink: true,
        isPlugin:true,
        link:'/translate',
        prompt: 'Quickly translates text and files between numerous languages',
        icon: `language.svg`
      },
   
      {
        id: 5,
        title: 'Smart Summary',
        isBeta: false,
        isLink: false,
        isPlugin:false,
        prompt: 'Give me a detailed document summary',
        icon: `doc.svg`
      },
      { id: 3, 
        title: 'Code Generation', 
        isBeta: false,
        isLink: false,
        isPlugin:false,
        prompt: 'Reverse a string in Python using slicing or a loop for varying lengths.', 
        icon: `prompt-code.svg` 
      },
      {
        id: 4,
        title: 'Test Case Template',
        isBeta: false,
        isLink: false,
        isPlugin:false,
        prompt: 'Design a test case template for objectives, data, results, and outcomes. ',
        icon: `testcase.svg`,
      },
      // {
      //   id: 5,
      //   title: 'Language Translation',
      //   isBeta: false,
      //   isLink: false,
      //   isPlugin:false,
      //   prompt: ' Translate the phrase "Hello, how are you?" into [Language]',
      //   icon: `language.svg`
      // },
      { 
        id: 6, 
        title: 'Job Posting',
        isBeta: false,
        isLink: false,
        isPlugin:false,
        prompt: 'Write a job posting for [job title] that attracts qualified candidates.', 
        icon: `job.svg` 
      },
      
      { 
        id: 7, 
        title: 'Micro Metropolis',
        isBeta: false,
        isLink: false,
        isPlugin:false,
        prompt: 'Create an image of a futuristic city built on a giant tree leaf.', 
        icon: `imageai.svg` 
      },
    
    ]

    // this.coreAIService.getpromptList(10).subscribe((res: any) => {
    //   if (res?.result?.length > 0) {
    //     this.promptList = res.result;
    //   }
    // })
  };


  getIconPath(iconName: string): string {
    return `/assets/images/icons/${iconName}`;
  }


}
